// Format API decimal dollars without floating-point rounding or changing storage.
export default function formatHistoryMoney(value) {
  if (value == null) return 'Unavailable';
  const match = /^(-?)(\d+)(?:\.(\d+))?$/.exec(String(value));
  if (!match) return 'Unavailable';
  const fraction = (match[3] || '').padEnd(3, '0');
  let cents = `${match[2]}${fraction.slice(0, 2)}`.replace(/^0+(?=\d)/, '');
  if (fraction[2] >= '5') {
    const digits = cents.split('');
    let carry = 1;
    for (let i = digits.length - 1; i >= 0 && carry; i -= 1) {
      const next = Number(digits[i]) + carry;
      digits[i] = String(next % 10);
      carry = next >= 10 ? 1 : 0;
    }
    cents = `${carry || ''}${digits.join('')}`;
  }
  cents = cents.padStart(3, '0');
  const sign = match[1] && /[1-9]/.test(cents) ? '-' : '';
  return `${sign}$${cents.slice(0, -2)}.${cents.slice(-2)}`;
}
